import { atom } from 'jotai';
import keyBy from 'lodash/keyBy';

import { facilitiesQueryAtom } from '../_graphql/queryFacilities';

export const $remoteFacilities = facilitiesQueryAtom(() => ({}));

export const $facilitiesById = atom((get) => {
  const { data: facilitiesData } = get($remoteFacilities);

  return keyBy(facilitiesData?.facilities, 'id');
});
